import { render, staticRenderFns } from "./curso-resultado-pregunta.vue?vue&type=template&id=d33f1ae6&scoped=true&"
import script from "./curso-resultado-pregunta.vue?vue&type=script&lang=ts&"
export * from "./curso-resultado-pregunta.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d33f1ae6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
